export function suffixFunction(value: number): string {
  return value === 1 ? '' : 's';
}
